import React from "react";
import {Brands} from "@core-ui/utility";
import {ResponsiveIcon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandLargeViewBoxSVG = (
  <svg
    height="48"
    viewBox="0 0 48 48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24z"
      fill="#F2F2F2"
    />
    <path d="M15 15a3 3 0 116 0v18a3 3 0 11-6 0V15zM27 15a3 3 0 116 0v18a3 3 0 11-6 0V15z" />
  </svg>
);

const CrossBrandSmallViewBoxSVG = (
  <svg
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
      fill="#F2F2F2"
    />
    <path d="M10 10a2 2 0 114 0v12a2 2 0 11-4 0V10zM18 10a2 2 0 114 0v12a2 2 0 11-4 0V10z" />
  </svg>
);

const brandIconLargeViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.Gap]: CrossBrandLargeViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.OldNavy]: CrossBrandLargeViewBoxSVG,
  crossBrand: CrossBrandLargeViewBoxSVG,
};

const brandIconSmallViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.Gap]: CrossBrandSmallViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.OldNavy]: CrossBrandSmallViewBoxSVG,
  crossBrand: CrossBrandSmallViewBoxSVG,
};

export const PauseCircleIcon = (props: IconContainerProps): JSX.Element => (
  <ResponsiveIcon
    {...props}
    brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
    brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
  />
);
